import { render, staticRenderFns } from "./CotPuaSedeUtentiListComponent.vue?vue&type=template&id=367b6c33"
import script from "./CotPuaSedeUtentiListComponent.vue?vue&type=script&lang=js"
export * from "./CotPuaSedeUtentiListComponent.vue?vue&type=script&lang=js"
import style0 from "./CotPuaSedeUtentiListComponent.vue?vue&type=style&index=0&id=367b6c33&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports